import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Container, Divider, Typography } from "@mui/material";
import { Block } from "@mui/icons-material";
import ChartTotal from "./ChartTotal";
import "../../css/dashboard.css";
import { useState } from "react";
import moment from "moment";
import { useEffect } from "react";
import ChartIn from "./ChartIn";
import ChartOut from "./ChartOut";
import ChartTs from "./ChartTs";
import ChartPieT2 from "./ChartPieT2";
import ChartPieT1 from "./ChartPieT1";
import ChartInFlt from "./ChartInFlt";
import ChartOutFlt from "./ChartOutFlt";
import ChartTsFlt from "./ChartTsFlt";

export default function DashBoardTap({ value, time }) {
  const [searchData, setSearchData] = useState([]);
  const [inbound, setInbound] = useState([]);
  const [outbound, setOutbound] = useState([]);
  const [tsbound, setTsbound] = useState([]);
  const [beforeVolume, setBeforeVolume] = useState(null);
  const [volume, setVolume] = useState(null);
  const [rate, setRate] = useState(null);
  const [t1Data, setT1Data] = useState([]);
  const [t2Data, setT2Data] = useState([]);
  const [totalData, setTotalData] = useState([]);
  const [inFlt, setInFlt] = useState([]);
  const [outFlt, setOutFlt] = useState([]);
  const [tsFlt, setTsFlt] = useState([]);

  const apiUrl = process.env.REACT_APP_APICARGO;

  // useEffect(() => {
  //   if (value === 0) {
  //     fetch(`${apiUrl}/sams/stweek?date=20220212`)
  //       .then((response) => {
  //         if (!response.ok) {
  //           throw new Error(
  //             `Network response was not ok: ${response.statusText}`
  //           );
  //         }
  //         return response.json();
  //       })
  //       .then((res) => {
  //         if (res.length === 0) {
  //         } else {
  //           const searchDatas = res.map((row, index) => ({
  //             id: index,
  //             inoutFlag: row.inoutFlag,
  //             fltNo: row.fltNo,
  //             fltDate: row.fltDate,
  //             carrierCode: row.carrierCode,
  //             originCode: row.originCode,
  //             count: row.count,
  //             weight: row.weight,
  //             terminalCode: row.terminalCode,
  //           }));
  //           setSearchData(searchDatas);
  //           setOutbound(searchData.filter((item) => item.inoutFlag === "E"));
  //           setInbound(searchData.filter((item) => item.inoutFlag === "I"));
  //           setTsbound(searchData.filter((item) => item.inoutFlag === "T"));
  //         }
  //       });
  //   }
  // }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/sams/stweek?date=${time}`);
        if (!response.ok) {
          throw new Error(
            `Network response was not ok: ${response.statusText}`
          );
        }

        const res = await response.json();

        if (res.length === 0) {
          // 처리할 내용이 있다면 여기에 추가
        } else {
          const searchData = res.reverse().map((row, index) => ({
            id: index,
            inoutFlag: row.inoutFlag,
            fltNo: row.fltNo,
            fltDate: row.fltDate,
            carrierCode: row.carrierCode,
            originCode: row.originCode,
            count: row.count,
            weight: row.weight / 1000,
            terminalCode: row.terminalCode,
            bupWeight: row.bupWeight / 1000,
          }));

          // setSearchData를 사용하여 데이터 업데이트
          setSearchData(searchData);

          // 데이터 업데이트 후에 다음 상태를 업데이트
          setOutbound(searchData.filter((item) => item.inoutFlag === "E"));
          setInbound(searchData.filter((item) => item.inoutFlag === "I"));
          setTsbound(searchData.filter((item) => item.inoutFlag === "T"));
          setT1Data(
            searchData.filter(
              (item) => item.terminalCode === "T1" && item.fltDate === time
            )
          );
          setT2Data(
            searchData.filter(
              (item) => item.terminalCode === "T2" && item.fltDate === time
            )
          );
          setTotalData(searchData.filter((item) => item.fltDate === time));
          setInFlt(
            searchData.filter(
              (item) => item.inoutFlag === "I" && item.fltDate === time
            )
          );
          setOutFlt(
            searchData.filter(
              (item) => item.inoutFlag === "E" && item.fltDate === time
            )
          );
          setTsFlt(
            searchData.filter(
              (item) => item.inoutFlag === "T" && item.fltDate === time
            )
          );
          const fltDateToFind = time;
          const nowDate = moment(fltDateToFind, "YYYYMMDD");
          const lastWeek = nowDate.subtract(7, "days").format("YYYYMMDD");
          const fltNoToFind = lastWeek;

          // fltNo가 "20220219"인 항목들을 필터링
          const filteredData = searchData.filter(
            (item) => item.fltDate === fltNoToFind
          );
          const filteredDataNow = searchData.filter(
            (item) => item.fltDate === fltDateToFind
          );

          // 총 weight 계산
          const totalWeight = filteredData.reduce(
            (sum, item) => sum + item.weight,
            0
          );
          const totalWeightNow = filteredDataNow.reduce(
            (sum, item) => sum + item.weight,
            0
          );
          const formattedTotalWeight = totalWeight.toFixed(2);
          const formattedTotalWeightNow = totalWeightNow.toFixed(2);
          const increaseRate =
            ((formattedTotalWeightNow - formattedTotalWeight) /
              formattedTotalWeight) *
            100;
          const lastRate = increaseRate.toFixed(2);
          setBeforeVolume(formattedTotalWeight);
          setVolume(formattedTotalWeightNow);
          setRate(lastRate);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchData2 = async () => {
      try {
        const response = await fetch(`${apiUrl}/sams/stmonth?date=${time}`);
        if (!response.ok) {
          throw new Error(
            `Network response was not ok: ${response.statusText}`
          );
        }

        const res = await response.json();

        if (res.length === 0) {
          // 처리할 내용이 있다면 여기에 추가
        } else {
          const searchData = res.reverse().map((row, index) => ({
            id: index,
            inoutFlag: row.inoutFlag,
            fltNo: row.fltNo,
            fltDate: row.fltDate,
            carrierCode: row.carrierCode,
            originCode: row.originCode,
            count: row.count,
            weight: row.weight / 1000,
            terminalCode: row.terminalCode,
            bupWeight: row.bupWeight / 1000,
          }));

          // setSearchData를 사용하여 데이터 업데이트
          setSearchData(searchData);

          // 데이터 업데이트 후에 다음 상태를 업데이트
          setOutbound(searchData.filter((item) => item.inoutFlag === "E"));
          setInbound(searchData.filter((item) => item.inoutFlag === "I"));
          setTsbound(searchData.filter((item) => item.inoutFlag === "T"));
          setT1Data(
            searchData.filter(
              (item) => item.terminalCode === "T1" && item.fltDate === time
            )
          );
          setT2Data(
            searchData.filter(
              (item) => item.terminalCode === "T2" && item.fltDate === time
            )
          );
          setTotalData(searchData.filter((item) => item.fltDate === time));
          setInFlt(
            searchData.filter(
              (item) => item.inoutFlag === "I" && item.fltDate === time
            )
          );
          setOutFlt(
            searchData.filter(
              (item) => item.inoutFlag === "E" && item.fltDate === time
            )
          );
          setTsFlt(
            searchData.filter(
              (item) => item.inoutFlag === "T" && item.fltDate === time
            )
          );
          const fltDateToFind = time;
          const nowDate = moment(fltDateToFind, "YYYYMMDD");
          const lastWeek = nowDate.subtract(1, "months").format("YYYYMMDD");
          const fltNoToFind = lastWeek;

          // fltNo가 "20220219"인 항목들을 필터링
          const filteredData = searchData.filter(
            (item) => item.fltDate === fltNoToFind
          );
          const filteredDataNow = searchData.filter(
            (item) => item.fltDate === fltDateToFind
          );

          // 총 weight 계산
          const totalWeight = filteredData.reduce(
            (sum, item) => sum + item.weight,
            0
          );
          const totalWeightNow = filteredDataNow.reduce(
            (sum, item) => sum + item.weight,
            0
          );
          const formattedTotalWeight = totalWeight.toFixed(2);
          const formattedTotalWeightNow = totalWeightNow.toFixed(2);
          const increaseRate =
            ((formattedTotalWeightNow - formattedTotalWeight) /
              formattedTotalWeight) *
            100;
          const lastRate = increaseRate.toFixed(2);
          setBeforeVolume(formattedTotalWeight);
          setVolume(formattedTotalWeightNow);
          setRate(lastRate);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchData3 = async () => {
      try {
        const response = await fetch(`${apiUrl}/sams/styear?date=${time}`);
        if (!response.ok) {
          throw new Error(
            `Network response was not ok: ${response.statusText}`
          );
        }

        const res = await response.json();

        if (res.length === 0) {
          // 처리할 내용이 있다면 여기에 추가
        } else {
          const searchData = res.reverse().map((row, index) => ({
            id: index,
            inoutFlag: row.inoutFlag,
            fltNo: row.fltNo,
            fltDate: row.fltDate,
            carrierCode: row.carrierCode,
            originCode: row.originCode,
            count: row.count,
            weight: row.weight / 1000,
            terminalCode: row.terminalCode,
            bupWeight: row.bupWeight / 1000,
          }));

          // setSearchData를 사용하여 데이터 업데이트
          setSearchData(searchData);

          // 데이터 업데이트 후에 다음 상태를 업데이트
          setOutbound(searchData.filter((item) => item.inoutFlag === "E"));
          setInbound(searchData.filter((item) => item.inoutFlag === "I"));
          setTsbound(searchData.filter((item) => item.inoutFlag === "T"));
          setT1Data(
            searchData.filter(
              (item) => item.terminalCode === "T1" && item.fltDate === time
            )
          );
          setT2Data(
            searchData.filter(
              (item) => item.terminalCode === "T2" && item.fltDate === time
            )
          );
          setTotalData(searchData.filter((item) => item.fltDate === time));
          setInFlt(
            searchData.filter(
              (item) => item.inoutFlag === "I" && item.fltDate === time
            )
          );
          setOutFlt(
            searchData.filter(
              (item) => item.inoutFlag === "E" && item.fltDate === time
            )
          );
          setTsFlt(
            searchData.filter(
              (item) => item.inoutFlag === "T" && item.fltDate === time
            )
          );
          const fltDateToFind = time;
          const nowDate = moment(fltDateToFind, "YYYYMMDD");
          const lastWeek = nowDate.subtract(1, "years").format("YYYYMMDD");
          const fltNoToFind = lastWeek;

          // fltNo가 "20220219"인 항목들을 필터링
          const filteredData = searchData.filter(
            (item) => item.fltDate === fltNoToFind
          );
          const filteredDataNow = searchData.filter(
            (item) => item.fltDate === fltDateToFind
          );

          // 총 weight 계산
          const totalWeight = filteredData.reduce(
            (sum, item) => sum + item.weight,
            0
          );
          const totalWeightNow = filteredDataNow.reduce(
            (sum, item) => sum + item.weight,
            0
          );
          const formattedTotalWeight = totalWeight.toFixed(0);
          const formattedTotalWeightNow = totalWeightNow.toFixed(0);
          const increaseRate =
            ((formattedTotalWeightNow - formattedTotalWeight) /
              formattedTotalWeight) *
            100;
          const lastRate = increaseRate.toFixed(2);
          setBeforeVolume(formattedTotalWeight);
          setVolume(formattedTotalWeightNow);
          setRate(lastRate);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (value === 0) {
      fetchData();
    } else if (value === 1) {
      fetchData2();
    } else if (value === 2) {
      fetchData3();
    }
  }, []); // 빈 배열을 전달하여 최초 한 번만 실행

  const paperStyle = {
    width: 545,
    height: 235,
  };
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  return (
    <Box sx={{ flexGrow: 1, width: "1930px" }}>
      <Grid container spacing={2}>
        <Grid item xs={3.55}>
          <Item sx={{ marginBottom: 1 }}>
            <Paper sx={{ ...paperStyle }}>
              <Typography
                sx={{
                  textAlign: "left",
                  paddingLeft: 3.5,
                  backgroundColor: "#264E49",
                  color: "#ffffff",
                  fontSize: "1.00rem",
                }}
                variant="h6"
              >
                수입
              </Typography>
              <ChartIn data={inbound} />
            </Paper>
          </Item>
          <Item sx={{ marginBottom: 1 }}>
            <Paper sx={{ ...paperStyle }}>
              <Typography
                sx={{
                  textAlign: "left",
                  paddingLeft: 3.5,
                  backgroundColor: "#ff6666",
                  color: "#ffffff",
                  fontSize: "1.00rem",
                }}
                variant="h6"
              >
                수출
              </Typography>
              <ChartOut data={outbound} />
            </Paper>
          </Item>
          <Item sx={{ marginBottom: 1 }}>
            <Paper sx={{ ...paperStyle }}>
              <Typography
                sx={{
                  textAlign: "left",
                  paddingLeft: 3.5,
                  backgroundColor: "#009999",
                  color: "#ffffff",
                  fontSize: "1.00rem",
                }}
                variant="h6"
              >
                환적
              </Typography>

              <ChartTs data={tsbound} />
            </Paper>
          </Item>
        </Grid>
        <Grid item xs={3.75}>
          <Grid item sx={{ display: "flex", height: 150, width: 600 }}>
            <Item sx={{ width: 200, marginRight: 1 }}>
              <Typography
                sx={{
                  textAlign: "center",
                  backgroundColor: "#478ba2",
                  color: "#ffffff",
                  fontSize: "1.00rem",
                }}
                variant="h6"
              >
                {value === 0
                  ? "전주 물동량"
                  : value === 1
                  ? "전월 물동량"
                  : "전년 물동량"}
              </Typography>
              <Divider />
              <div>
                <p className="dashP">
                  {beforeVolume === null ? 0 : beforeVolume}
                </p>
              </div>
            </Item>
            <Item sx={{ width: 200, marginRight: 1 }}>
              <Typography
                sx={{
                  textAlign: "center",
                  backgroundColor: "#478ba2",
                  color: "#ffffff",
                  fontSize: "1.00rem",
                }}
                variant="h6"
              >
                {value === 0
                  ? "주간 물동량"
                  : value === 1
                  ? "월간 물동량"
                  : "년간 물동량"}
              </Typography>
              <Divider />
              <div>
                <p className="dashP">{volume === null ? 0 : volume}</p>
              </div>
            </Item>
            <Item sx={{ width: 200, marginRight: 1 }}>
              <Typography
                sx={{
                  textAlign: "center",
                  backgroundColor: "#478ba2",
                  color: "#ffffff",
                  fontSize: "1.00rem",
                }}
                variant="h6"
              >
                상승률
              </Typography>
              <Divider />
              <div>
                <p className="dashP">{rate === null ? 0 : rate}%</p>
              </div>
            </Item>
          </Grid>
          <Grid
            item
            sx={{ display: "flex", height: 300, width: 600, marginTop: 1 }}
          >
            <Item sx={{ width: 292, marginRight: 1 }}>
              <Typography
                sx={{
                  textAlign: "center",
                  backgroundColor: "#3C6E71",
                  color: "#ffffff",
                  fontSize: "1.10rem",
                }}
                variant="h6"
              >
                T1
              </Typography>
              <Divider />
              <ChartPieT1 data={t1Data} />
            </Item>
            <Item sx={{ width: 292 }}>
              <Typography
                sx={{
                  textAlign: "center",
                  backgroundColor: "#9BBA74",
                  color: "#ffffff",
                  fontSize: "1.10rem",
                }}
                variant="h6"
              >
                T2
              </Typography>
              <Divider />
              <ChartPieT2 data={t2Data} />
            </Item>
          </Grid>
          <Grid
            item
            sx={{ display: "flex", height: 300, width: 600, marginTop: 1 }}
          >
            <Item sx={{ width: 593 }}>
              <Typography
                sx={{
                  textAlign: "left",
                  backgroundColor: "#333333",
                  paddingLeft: 6,
                  color: "#ffffff",
                  fontSize: "1.00rem",
                }}
                variant="h6"
              >
                수출입 물동량 TOTAL
              </Typography>
              <ChartTotal data={totalData} />
            </Item>
          </Grid>
        </Grid>
        <Grid item xs={3.9}>
          <Grid sx={{ width: 600 }}>
            <Item sx={{ marginBottom: 1 }}>
              <Paper sx={{ height: 235 }}>
                <Typography
                  sx={{
                    textAlign: "left",
                    paddingLeft: 3.5,
                    backgroundColor: "#264E49",
                    color: "#ffffff",
                    fontSize: "1.00rem",
                  }}
                  variant="h6"
                >
                  수입 항공사별
                </Typography>
                <ChartInFlt data={inFlt} />
              </Paper>
            </Item>
            <Item sx={{ marginBottom: 1 }}>
              <Paper sx={{ height: 235 }}>
                <Typography
                  sx={{
                    textAlign: "left",
                    paddingLeft: 3.5,
                    backgroundColor: "#ff6666",
                    color: "#ffffff",
                    fontSize: "1.00rem",
                  }}
                  variant="h6"
                >
                  수출 항공사별
                </Typography>
                <ChartOutFlt data={outFlt} />
              </Paper>
            </Item>
            <Item>
              <Paper sx={{ height: 235 }}>
                <Typography
                  sx={{
                    textAlign: "left",
                    paddingLeft: 3.5,
                    backgroundColor: "#009999",
                    color: "#ffffff",
                    fontSize: "1.00rem",
                  }}
                  variant="h6"
                >
                  환적 항공사별
                </Typography>
                <ChartTsFlt data={tsFlt} />
              </Paper>
            </Item>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
